import { useState } from "react";

const parse = (val) => {
  let m = /^RIR (\d+)-(\d+) \((\d+)-(\d+) reps\)$/.exec(val || "");
  if (m) return { mode: "rir", rirMin: m[1], rirMax: m[2], repMin: m[3], repMax: m[4] };
  m = /^Échec \(> (\d+) reps\)$/.exec(val || "");
  if (m) return { mode: "echec", reps: m[1] };
  m = /^(\d+) min$/.exec(val || "");
  if (m) return { mode: "duree", min: m[1] };
  return { mode: "libre" };
};

export const ObjectifField = ({ value, onChange }) => {
  const [mode, setMode] = useState(parse(value).mode);
  const p = parse(value);
  const num = (v, fallback) => (v === "" || isNaN(parseInt(v, 10)) ? fallback : parseInt(v, 10));

  const setRir = (rirMin, rirMax, repMin, repMax) =>
    onChange(`RIR ${rirMin}-${rirMax} (${repMin}-${repMax} reps)`);

  const switchMode = (m) => {
    setMode(m);
    if (m === "rir") setRir(1, 2, 8, 12);
    else if (m === "echec") onChange("Échec (> 10 reps)");
    else if (m === "duree") onChange("5 min");
  };

  return (
    <div className="space-y-1.5" data-testid="objectif-field">
      <select data-testid="objectif-mode-select" className="auth-input" value={mode}
        onChange={(e) => switchMode(e.target.value)}>
        <option value="rir">RIR + plage de reps</option>
        <option value="echec">Échec (&gt; X reps)</option>
        <option value="duree">Durée (min)</option>
        <option value="libre">Texte libre</option>
      </select>
      {mode === "rir" && (
        <div className="grid grid-cols-4 gap-1.5">
          <input data-testid="objectif-rir-min" type="number" min="0" max="5" className="auth-input" title="RIR min"
            value={p.rirMin ?? 1} onChange={(e) => setRir(num(e.target.value, 1), p.rirMax ?? 2, p.repMin ?? 8, p.repMax ?? 12)} />
          <input data-testid="objectif-rir-max" type="number" min="0" max="5" className="auth-input" title="RIR max"
            value={p.rirMax ?? 2} onChange={(e) => setRir(p.rirMin ?? 1, num(e.target.value, 2), p.repMin ?? 8, p.repMax ?? 12)} />
          <input data-testid="objectif-rep-min" type="number" min="1" className="auth-input" title="Reps min"
            value={p.repMin ?? 8} onChange={(e) => setRir(p.rirMin ?? 1, p.rirMax ?? 2, num(e.target.value, 8), p.repMax ?? 12)} />
          <input data-testid="objectif-rep-max" type="number" min="1" className="auth-input" title="Reps max"
            value={p.repMax ?? 12} onChange={(e) => setRir(p.rirMin ?? 1, p.rirMax ?? 2, p.repMin ?? 8, num(e.target.value, 12))} />
        </div>
      )}
      {mode === "rir" && <p className="text-[#6a6a6e] text-[10px]">RIR min · RIR max · reps min · reps max</p>}
      {mode === "echec" && (
        <input data-testid="objectif-echec-reps" type="number" min="1" className="auth-input" title="Seuil de reps"
          value={p.reps ?? 10} onChange={(e) => onChange(`Échec (> ${num(e.target.value, 10)} reps)`)} />
      )}
      {mode === "duree" && (
        <input data-testid="objectif-duree-min" type="number" min="1" className="auth-input" title="Minutes"
          value={p.min ?? 5} onChange={(e) => onChange(`${num(e.target.value, 5)} min`)} />
      )}
      {mode === "libre" && (
        <input data-testid="row-objectif" className="auth-input" value={value}
          onChange={(e) => onChange(e.target.value)} placeholder="Objectif" />
      )}
      <p data-testid="objectif-preview" className="text-[#FF6B61] text-xs font-semibold">Badge : {value || "—"}</p>
    </div>
  );
};
